/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-column-gap:24px;column-gap:24px}.option[_ngcontent-%COMP%]{border:1px solid #dcdcdc;border-radius:8px;width:238px;height:128px;background-color:#fff;outline:none;cursor:pointer}.option-selected[_ngcontent-%COMP%]{border:1px solid #0078ff;border-bottom-width:4px}.option[_ngcontent-%COMP%]:hover:not(.option-disabled){border-bottom-width:4px}.option[_ngcontent-%COMP%]:not(.option-selected):not(.option-untouched)   img[_ngcontent-%COMP%]{-webkit-filter:grayscale(100%) brightness(1.5);filter:grayscale(100%) brightness(1.5)}.option-disabled[_ngcontent-%COMP%]{cursor:not-allowed}.option-disabled[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{-webkit-filter:grayscale(100%) brightness(1.5);filter:grayscale(100%) brightness(1.5)}"];
export { styles as styles };
//# sourceMappingURL=live-class-survey-image-selector.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/live-class-survey/live-class-survey-image-selector/live-class-survey-image-selector.component.scss.shim.ngstyle.js
// module id = 1317
// module chunks = 27 28 29